import React, {useState} from "react";
import PasswordStep from "./PasswordStep";
import {isEmail} from "validator";
import {Box, Button, Paper, Stack, TextField, Typography} from "@mui/material";

interface EmailStepProps {
    onStartEmailAuth: () => void;
}

const EmailStep: React.FC<EmailStepProps> = ({onStartEmailAuth}) => {
    const [email, setEmail] = useState("");
    const [error, setError] = useState<string | null>(null);
    const [showPasswordStep, setShowPasswordStep] = useState(false);

    const handleNext = () => {
        const trimmedEmail = email.trim();
        if (isEmail(trimmedEmail)) {
            setShowPasswordStep(true);
            onStartEmailAuth();
            return;
        }

        setError("Ongeldig e-mailadres");
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);

        if (error) setError(null); // Clear error when user starts typing
    };

    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            handleNext();
        }
    };

    if (showPasswordStep) {
        return <PasswordStep email={email.trim()}/>;
    }

    return (
                <Stack>
                    <TextField
                        fullWidth
                        label="Voer uw email in"
                        type="email"
                        value={email}
                        onChange={handleChange}
                        onKeyDown={handleKeyPress}
                        error={!!error}
                        helperText={error}
                    />

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleNext}
                        disabled={!email || !!error}
                        fullWidth
                    >
                        Verder
                    </Button>
                </Stack>
            
    );
};

export default EmailStep;
